import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow } from "swiper/modules";

import "./main.css";

window.Swiper = Swiper;
window.SwiperModules = {
    Navigation,
    Pagination,
    Scrollbar,
    Autoplay,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
};
